import {
    buildRecordLifecyclePagedListActions,
    type RecordLifecycleConfirmKind,
} from "../../utils/navigation/recordLifecycleActions";
import { EntityLabels } from "../../utils/navigation/pageTitles";

export type LocationAdminConfirmKind = RecordLifecycleConfirmKind;

export function formatLocationToastLabel(name: string | undefined): string {
    const t = typeof name === "string" ? name.trim() : "";
    return t.length > 0 ? t : EntityLabels.location;
}

export function getLocationAdminActionSuccessMessage(
    kind: LocationAdminConfirmKind,
    name: string | undefined
): string {
    const label = formatLocationToastLabel(name);
    const successByKind: Record<LocationAdminConfirmKind, string> = {
        disable: `${label} disabled successfully!`,
        enable: `${label} enabled successfully!`,
        softDelete: `${label} deleted successfully!`,
        restore: `${label} restored successfully!`,
    };
    return successByKind[kind];
}

export type LocationAdminListRow = {
    id: string;
    name: string;
    isEnabled?: boolean;
    isDeleted?: boolean;
};

export const buildLocationAdminPagedListActions =
    buildRecordLifecyclePagedListActions<LocationAdminListRow>;

export function canMutateLocations(roleNames: string[]): boolean {
    const allowed = new Set([
        "System Administrator",
        "Administrator",
        "Office Staff",
        "Yard Staff",
    ]);
    return roleNames.some((r) => allowed.has(r));
}
